import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { ReactComponent as CupWater } from "../assets/CupWater.svg";


function WaterCup(props) {

  return (
    <SvgIcon {...props} viewBox="0 0 300 513">
      <CupWater/>
    </SvgIcon>
  );
}

export default WaterCup;
